export default __webpack_public_path__ + "347ab39276345d925ca8f3ecfc371397.png";